// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"3de531e8","273":"70f5f37c","917":"cf291816"}[chunkId] + ".chunk.js";
};